import * as actions from './actions';
import * as constants from './constants';

export default { ...actions, ...constants };
